<template>
  <div class="row filter">
    <div class="col-md-10 offset-md-1">
      <div class="filter-header">
        <ul class="nav nav-tabs" id="alarms" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="stato-tab" data-toggle="tab" href="#" role="tab" aria-controls="stato" aria-selected="true" @click.prevent="changeTab('stato-tab')">Stato</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="storico-tab" data-toggle="tab" href="#" role="tab" aria-controls="storico" aria-selected="false" @click.prevent="changeTab('storico-tab')">Storico</a>
          </li>
        </ul>
      </div>
      <div class="tab-content" id="alarmsContent">
        <div class="tab-pane fade show active" id="tab" role="tabpanel" aria-labelledby="tab">
          <div class="filter-body">
            <div class="row gray-bg">
              <div class="col-md-6">
                <span class="filter-span">dispositivo</span>
                    
                <synoptic-filter class="mb-4" page="alarms" :select-devices="selectDevices" :reset="reset" type="filter"></synoptic-filter>
              </div>
              <div class="col-md-6">
                <span class="filter-span">allarme</span>
                    
                <vue-select id="alarms-parameters" key="alarms-parameters" :reset="reset" :locked="locked['parameters']" :attributes="fields.parametersAttributes" @changed="changed"></vue-select>
              </div>
            </div>
                
            <div v-if="tab == 'storico-tab'" class="row">
              <div class="col-md-6">
                <span class="filter-span">periodo</span>
                    
                <vue-datepicker id="alarms-lowerbound" key="alarms-lowerbound" :reset="reset" :locked="locked['lowerbound']" :attributes="fields.lowerboundAttributes" @changed="changed"></vue-datepicker>
              </div>
              <div class="col-md-6">
                <span class="filter-span">&nbsp;</span>
                    
                <vue-datepicker id="alarms-upperbound" key="alarms-upperbound" :reset="reset" :locked="locked['upperbound']" :attributes="fields.upperboundAttributes" @changed="changed"></vue-datepicker>
              </div>
            </div>
                
            <div class="row filter-label">
              <!--<p>filtra per tipologia di stato</p>
              
              <div>
                <a href="#" class="icon-button check-mark">&nbsp;</a>
                <a href="#" class="icon-button alert-triangle filter-disabled">&nbsp;</a>
                <a href="#" class="icon-button alert-octagon">&nbsp;</a>
                <a href="#" class="icon-button lightning-no">&nbsp;</a>
              </div>
              -->
              <div>
                <a class="button dark" href="#" @click.prevent="resetForm">reset</a>
                <a class="button primary" href="#" @click.prevent="getData">visualizza</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
        
    <overlay :enabled="loading"></overlay>
  </div>
</template>

<script>
  import SynopticFilter from '@/layouts/Synoptic/Filter.vue';
  import notificator from '../../mixins/notificator';
  import { mapGetters } from 'vuex'

  import VueSelect from '@/components/Fields/Select.vue';
  import VueDatepicker from '@/components/Fields/Datepicker.vue';

  import Overlay from '@/components/Overlay.vue';

  export default {
    props: ['selectDevices', 'settings'],

    components: {SynopticFilter, VueSelect, VueDatepicker, Overlay},

    mixins: [notificator],

    data() {
      return {
        tab: 'stato-tab',
        parameters: [],
        loading: false,
        reset: null,
        ready: false,
        locked: {
          parameters: true,
          lowerbound: false,
          upperbound: false,
        },

        fields: {
          parametersAttributes: {},
          lowerboundAttributes: {},
          upperboundAttributes: {}
        },
      }
    },

    created() {
      this.broadcastTab();
      
      //Parameters
      this.fields.parametersAttributes = this.settings.parametersAttributes;
      this.fields.parametersAttributes['value']['value'] = this.selectedAlarmsParameters;
      
      //Lowerbound
      this.fields.lowerboundAttributes = this.settings.lowerboundAttributes;
      this.fields.lowerboundAttributes['value']['value'] = this.selectedAlarmsLowerbound;
      
      //Upperbound
      this.fields.upperboundAttributes = this.settings.upperboundAttributes;
      this.fields.upperboundAttributes['value']['value'] = this.selectedAlarmsUpperbound;
    
      if(this.selectedAlarmsDevices != null)
        this.getClientDeviceAlarms();
    },

    mounted() {
      this.ready = true;
    },

    computed: {    
      ...mapGetters([
        'token',
        'clientId',
        'selectedSite',

        'selectedAlarmsDevices',
        'selectedAlarmsParameters',
        'selectedAlarmsLowerbound',
        'selectedAlarmsUpperbound'        
      ])      
    },

    watch: {
      selectedAlarmsDevices() {
        if(this.selectedAlarmsDevices != null) {
          this.parameters = [];
          this.locked.parameters = true;
          this.getClientDeviceAlarms();
        }
      },

      selectedAlarmsParameters() {
        this.fields.parametersAttributes['value']['value'] = this.selectedAlarmsParameters;
      },
              
      selectedSite() {
        this.resetForm();
      }
    },

    methods: {
        changeTab(tab) {
          this.tab = tab;

          this.broadcastTab();
        },

        broadcastTab() {
          //Emetto evento get alarms
          this.$emit('change-tab', this.tab);
        },

        getClientDeviceAlarms() {
          this.overlay(true);

          this.$store
            .dispatch('getClientDeviceAlarms')
            .catch(error => {
                this.overlay(false);
                this.notify(this.$options.filters.notification({endpoint: 'GetClientDeviceAlarms', code: error}));            
            })
            .then(({data}) => {              
            this.overlay(false);

            /*
            if (error.response.data.mispErrorDTO.code != undefined)
            reject(error.response.data.mispErrorDTO.code);
            else
            reject(null);
            */
          
            this.notify(this.$options.filters.notification({endpoint: 'GetClientDeviceAlarms', code: 200}));
            
            this.fields.parametersAttributes.options.value = data.clientAlarms;
            this.parameters = data.parameters;

            this.locked.parameters = false;
          
          });          
        },

        getId(string) {
            var tmp = string.split("-");

            var response = '';
            for (let index = 0; index < tmp.length; index++) {
            response += this.getFirstLetterUppercase(tmp[index]);            
            }
            return response;
        },

        getFirstLetterUppercase(string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },

        changed(changed) {
            var id = this.getId(changed.id);
            
            var value = null;
            
            if(changed.value != null && changed.value != '')
              value = changed.value;
            
            this.$store.dispatch('change' + id, value);
        },
        
        validateFilter() {
            /* Facoltativo
            if(this.selectedAlarmsDevices['device']['id'] == undefined || this.selectedAlarmsDevices['device']['id'] == '' || this.selectedAlarmsDevices['device']['id'] == null) {
              this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 601}));
              return false;
            }
            */

           /* Facoltativo
            if(this.selectedAlarmsParameters == undefined || this.selectedAlarmsParameters == '' || this.selectedAlarmsParameters == null) {
              this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 602}));
              return false;
            }
            */
            
            if(this.tab == 'storico-tab') {
              if(this.selectedAlarmsUpperbound == undefined || this.selectedAlarmsUpperbound == '' || this.selectedAlarmsUpperbound == null) {
                this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 603}));
                return false;
              }
              
              if(this.selectedAlarmsLowerbound == undefined || this.selectedAlarmsLowerbound == '' || this.selectedAlarmsLowerbound == null) {
                this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 604}));
                return false;
              }
            }

            return true;
        },
        
        getData() {
            if(!this.ready || !this.validateFilter()) return;

            //Emetto evento get alarms
            this.$emit('get-alarms');
        },

        resetData() {
            //Emetto evento reset alarms
            this.$emit('reset-alarms');
        },

        overlay(action) {
            this.loading = action;
        }, 
        
        resetForm() {
          this.reset = (((1+Math.random())*0x10000)|0).toString(16).substring(1);

          this.resetData();
        },
    }
  }
</script>